import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Brain, History, LogOut, Trophy } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B0F17]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to={user ? "/instructions" : "/"} data-testid="logo-link" className="flex items-center gap-2.5 min-w-0">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-500 to-indigo-500 flex items-center justify-center">
            <Brain className="w-5 h-5 text-white" />
          </div>
          <span className="font-heading font-extrabold text-base sm:text-lg tracking-tight whitespace-nowrap">The Cognitive <span className="text-cyan-400">Metrics</span></span>
        </Link>

        {user && (
          <div className="flex items-center gap-3">
            <button
              data-testid="nav-leaderboard-button"
              onClick={() => navigate("/leaderboard")}
              className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-amber-400 transition-colors px-3 py-2 rounded-lg hover:bg-white/5"
            >
              <Trophy className="w-4 h-4" /> <span className="hidden sm:inline">Leaderboard</span>
            </button>
            <button
              data-testid="nav-history-button"
              onClick={() => navigate("/history")}
              className="flex items-center gap-1.5 text-sm text-slate-300 hover:text-cyan-400 transition-colors px-3 py-2 rounded-lg hover:bg-white/5"
            >
              <History className="w-4 h-4" /> <span className="hidden sm:inline">History</span>
            </button>
            {user.picture ? (
              <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full border border-white/20" />
            ) : (
              <div className="w-8 h-8 rounded-full bg-indigo-500 flex items-center justify-center text-sm font-semibold">
                {user.name?.[0] || "U"}
              </div>
            )}
            <button
              data-testid="logout-button"
              onClick={logout}
              className="text-slate-400 hover:text-rose-400 transition-colors p-2 rounded-lg hover:bg-white/5"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
